// extracted by mini-css-extract-plugin
export default {"wrapper":"ResultNameItem_wrapper__yhN32","info":"ResultNameItem_info__lLaSq"};